<template>
<div id="app">
    <loadingcomp ref="loadingcomp" v-bind:mesaj="loadingmesaj" v-model="loadingdialog"></loadingcomp>
    <v-card flat color="grey lighten-5">
        <v-layout row wrap>
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title>Bilet Raporu</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-flex xs12 sm3 md3>
                        <v-text-field flat="" prepend-inner-icon="live_help" id="searchtext" @keyup="searchliste = $event.target.value" ref="searchtext" @keyup.enter="biletara(searchliste)" solo-inverted="" hide-details label=" Ara" :append-icon-cb="biletarasearch" :append-icon="searchIcon">
                            <v-tooltip slot="prepend-inner" bottom>
                                <v-icon slot="activator" color="primary" dark>live_help</v-icon>
                                <span>Arama Yapılabilen Alanlar</span><br />
                                <v-divider color="yellow"></v-divider>
                                <template v-for="item in aramatipi">
                                    <span :key="item.id">{{item.text}}</span><br />
                                </template>
                            </v-tooltip>
                        </v-text-field>
                    </v-flex>
                </v-toolbar>
            </v-flex>
            <v-flex xs12 sm12>
                <v-form ref="formbiletrapor" v-model="valid" lazy-validation>
                    <v-container fluid="">
                        <v-card flat>
                            <v-layout class="project overdue" pa-1 row wrap="">
                                <v-flex xs12 sm3 md2>
                                    <tarihim :etiket="'Başlangıç Tarihi'" :detaygizle="false" v-model="date" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']">
                                    </tarihim>
                                </v-flex>
                                <!-- {{secilenkayitlaryedek.length}}
                                <v-btn @click="deneme()">dene</v-btn> -->
                                <v-flex xs12 sm3 md2>
                                    <tarihim :etiket="'Bitiş Tarihi'" :detaygizle="false" v-model="date2" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']">
                                    </tarihim>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-select hide-details="" :items="itemstip" label="Bilet Tipi" item-text="text" v-model="ListInput.Filtreler.BiletTipi" item-value="value">
                                    </v-select>
                                </v-flex>

                                <v-flex xs12 sm3 md2>
                                    <v-layout>
                                        <div v-if="load1">
                                            <v-btn color="info" @click="BiletListele(1,'SalesDate',50,false)" fab small="" dark>
                                                <v-icon>search</v-icon>
                                            </v-btn>
                                        </div>
                                        <div v-if="!load1">
                                            <v-layout fill-height="" align-center="">
                                                <v-progress-circular indeterminate color="primary">
                                                </v-progress-circular>
                                            </v-layout>
                                        </div>

                                        <v-badge color="white" :overlap="true">
                                            <template v-slot:badge>
                                                <v-icon v-if="filtrevarmi" medium left color="green">
                                                    check_circle_outline </v-icon>
                                            </template>

                                            <!-- <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()" color="info" fab dark>
                                                <v-icon>filter_list</v-icon>
                                            </v-btn>
                                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                                <span>Arama Filtresi Ekle</span>
                                            </v-tooltip> -->

                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn small="" v-on="on" ref="fab" @click="filtrele()" color="info" fab dark>
                                                        <v-icon>filter_list</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Arama Filtresi Ekle</span>
                                            </v-tooltip>
                                        </v-badge>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" color="green" @click="getTicketReportExcel()" fab small="" dark ref="fab">
                                                    <img style="height:32px; width:32px;" src="../../../assets/images/xls.png">
                                                </v-btn>
                                            </template>
                                            <span>Bilet Raporu İndir</span>
                                        </v-tooltip>

                                    </v-layout>
                                </v-flex>

                            </v-layout>
                        </v-card>
                    </v-container>
                </v-form>
            </v-flex>

            <v-dialog v-model="dialogfiltre" persistent="" scrollable="" max-width="550px">
                <v-card color="grey lighten-5">
                    <v-card-title>
                        <span class="headline">Filtre Seçimi</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-card>
                            <v-container fill-height fluid pa-2>
                                <v-layout row="" wrap="" fill-height>
                                    <v-flex xs12 sm6 md4>
                                        <tarihim :etiket="'Fatura Tarihi'" :detaygizle="false" clearable="" v-bind:defaultvalue="'null'" v-model="ListInput.Filtreler.FaturaTarihi" v-bind:value="ListInput.Filtreler.FaturaTarihi">
                                        </tarihim>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        <v-text-field label="Fatura Seri No" hide-details="" v-model="ListInput.Filtreler.FaturaSeri"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        <v-text-field hide-details="" type="number" label="Fatura No" v-model="ListInput.Filtreler.FaturaNo"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md12>
                                        <v-select hide-details="" clearable="" :items="itemsyon" label="Yön Seçimi" item-text="text" v-model="ListInput.Filtreler.HatTipi" item-value="value">
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <v-radio-group v-model="ListInput.Filtreler.FaturaStatus" label="Fatura Tipi" hide-details>
                                            <v-radio :value="0" label="Hepsi"></v-radio>
                                            <v-radio :value="1" label="Faturalanmamışlar"></v-radio>
                                            <v-radio :value="2" label="Faturalanmışlar"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <v-radio-group v-model="ListInput.Filtreler.GeciciCari" label="Cari Tipi" hide-details>
                                            <v-radio :value="0" label="Hepsi"></v-radio>
                                            <v-radio :value="1" label="Geçici Cariler Hariç"></v-radio>
                                            <v-radio :value="2" label="Sadece Geçici Cariler"></v-radio>
                                        </v-radio-group>
                                    </v-flex>

                                    <!--
                                            <v-flex xs12 sm12 md12>
                                                <v-text-field hide-details="" autofocus="" v-model="ListInput.BiletNo" mask="##########" label="Bilet Numarası">
                                                </v-text-field>
                                            </v-flex>

                                            <v-flex xs12 sm12 md12>
                                                <v-autocomplete hide-details="" clearable :items="itemsairlinelist" label="Havayolu Seçimi" multiple item-text="Title" v-model="ListInput.Filtreler.Havayollari" item-value="HavaYoluKodu">
                                                    <template slot="selection" slot-scope="{ item, index }">
                                                        <div v-if="index === 0">
                                                            <span>{{ item.HavaYoluKodu }}</span>
                                                        </div>
                                                        <span v-if="index === 1" class="grey--text caption">(+{{
                                                                ListInput.Filtreler.Havayollari.length -
                                                                1
                                                                }} diğer)</span>
                                                    </template>
                                                </v-autocomplete>
                                            </v-flex>
                                            -->
                                    <!--
                                            <v-layout row="" wrap="">

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-space-between column>
                                                        <v-select hide-details="" clearable="" :items="itemsyon" label="Yön Seçimi" multiple item-text="text" v-model="ListInput.Filtreler.HatTipi" item-value="value">
                                                            <template slot="selection" slot-scope="{ item, index }">
                                                                <div v-if="index === 0">
                                                                    <span>{{ item.text }}</span>
                                                                </div>
                                                                <span v-if="index === 1" class="grey--text caption">(+{{
                                                                        ListInput.Filtreler.HatTipi.length -
                                                                        1
                                                                        }} diğer)</span>
                                                            </template>
                                                        </v-select>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 md12 sm12>
                                                    <v-autocomplete hide-details="" clearable :items="itemsparkur" label="Parkur Seçimi" multiple item-text="Title" v-model="ListInput.Filtreler.Parkurlar" item-value="ParkurKod">
                                                        <template slot="selection" slot-scope="{ item, index }">
                                                            <div v-if="index === 0">
                                                                <span>{{ item.Aciklama }}</span>
                                                            </div>
                                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                                                ListInput.Filtreler.Parkurlar.length -
                                                                1
                                                                }} diğer)</span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-flex>

                                            </v-layout>
                                            -->
                                    <!-- <v-layout>
                                                    <v-flex xs12 sm12>
                                                        <v-autocomplete clearable :items="itemsparkur" hide-details=""
                                                            label="Uçuş Kalkış" item-text="Title"
                                                            v-model="ListInput.Filtreler.Ucus1" item-value="ParkurKod">
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-autocomplete clearable :items="itemsparkur" hide-details=""
                                                            label="Uçuş Varış" item-text="Title"
                                                            v-model="ListInput.Filtreler.Ucus2" item-value="ParkurKod">
                                                        </v-autocomplete>
                                                    </v-flex>

                                                </v-layout> -->

                                    <!-- <v-flex xs12 sm6>
                                                    <v-autocomplete :items="bankapositems" hide-datails tabindex="57"
                                                        hide-details="" v-model="ListInput.Filtreler.PosKod"
                                                        item-text="Title" item-value="PosKodu" clearable
                                                        label="Pos Seçim"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <kredikartcomp :tabdeger="'63'"
                                                        v-model="ListInput.Filtreler.KrediKartNo"></kredikartcomp>
                                                </v-flex> -->
                                    <!--
                                                <v-flex xs12 sm6>
                                                    <parainput :simge="getparabirimi()" :etiket="'Başlangıç Tutar'"
                                                        v-model="ListInput.Filtreler.BaslangicTutar"
                                                        :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <parainput :simge="getparabirimi()" :etiket="'Bitiş Tutar'"
                                                        v-model="ListInput.Filtreler.BitisTutar"
                                                        :autocomplete="'autocomplete'"></parainput>
                                                </v-flex> -->

                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-card-text>

                    <v-card-actions>

                    </v-card-actions>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="filtreiptal()">Filtre İptal</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Filtreleri Uygula</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-layout>
    </v-card>

    <v-layout row="" wrap v-if="listegorunum">

        <v-flex xs12 sm12 md12>
            <v-card flat="" color="grey lighten-5">
                <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md9>
                            <v-layout align-center="" fill-height="">
                                <div class=" font-weight-large grey--text title ">
                                    &nbsp; {{recordcount}} <span v-if="secilenkayitlar.length>0" class=" font-weight-large red--text title ">
                                        {{secilenkayitlar.length}} kayıt seçildi.. </span>
                                </div>
                            </v-layout>
                        </v-flex>
                        <v-flex v-show="kayitvarmi" xs12 sm12 md2>
                            <v-select hide-details="" :items="siralamatipiitems" color="grey darken-1" v-model="siralamatipi" item-text="text" item-value="value" label="Sıralama Tipi">
                            </v-select>
                        </v-flex>
                        <v-flex v-show="kayitvarmi" xs12 sm12 md1>
                            <v-select hide-details="" :items="kayitsayisi" color="grey darken-1" v-model="kayitadet" item-text="text" item-value="value" label="Göster"></v-select>
                        </v-flex>
                    </v-layout>

                </v-flex>
                <v-flex pa-2 v-for="item in filtreticket" v-bind:key="item.id" xs12 sm12 md12>
                    <v-hover>
                        <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" width="100%">
                            <v-list two-line="">
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-card flat class="black--text">
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <v-layout row wrap>

                                                        <v-flex sm12 md1>
                                                            <v-card flat="">
                                                                <v-list-tile>
                                                                    <v-list-tile-content>
                                                                        <v-img :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)" height="60%" width="60%" contain>
                                                                        </v-img>
                                                                        <v-img v-if="item.GenelBilgileri.Acente =='A'" :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)" alt="K" height="21px" width="86px" contain>
                                                                        </v-img>

                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </v-card>
                                                        </v-flex>

                                                        <v-flex xs12 sm4 md3>
                                                            <v-layout align-start justify-start row fill-height>
                                                                <v-card flat="">
                                                                    <v-list-tile>
                                                                        <v-list-tile-content>
                                                                            <v-layout row align-center justify-start>
                                                                                <v-chip v-if="item.GenelBilgileri.Status=='S' " small="" color="green" text-color="white">
                                                                                    Satış</v-chip>
                                                                                <v-chip v-if="item.GenelBilgileri.Status=='Ia' " small="" color="red" text-color="white">
                                                                                    İade</v-chip>
                                                                                <v-chip v-if="item.GenelBilgileri.Status=='V' " small="" color="yellow" text-color="white">
                                                                                    Void</v-chip>
                                                                                <v-list-tile-title>
                                                                                    <span class='grey-text--primary caption '>
                                                                                        {{item.GenelBilgileri.HavaYoluKodu}}
                                                                                        -
                                                                                        {{item.GenelBilgileri.BiletNo}}
                                                                                        -
                                                                                        {{item.GenelBilgileri.UcusTipi}}
                                                                                    </span>
                                                                                </v-list-tile-title>
                                                                            </v-layout>
                                                                            <v-list-tile-sub-title>
                                                                                &nbsp; <span class='grey-text--primary caption '>
                                                                                    {{item.GenelBilgileri.YolcuAdi}}</span>
                                                                            </v-list-tile-sub-title>
                                                                            <v-list-tile-sub-title>
                                                                                &nbsp; <span class='grey-text--primary caption '>
                                                                                    {{item.GenelBilgileri.MusteriKodu.Kod}}
                                                                                    -{{item.GenelBilgileri.MusteriKodu.Unvan}}
                                                                                </span>
                                                                            </v-list-tile-sub-title>
                                                                        </v-list-tile-content>
                                                                    </v-list-tile>
                                                                </v-card>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm4 md2>
                                                            <v-layout align-start justify-start row fill-height>
                                                                <v-card flat="">
                                                                    <v-list-tile>
                                                                        <v-list-tile-content>
                                                                            <v-layout row wrap align-center="" justify-start>
                                                                                <v-list-tile-title>
                                                                                    <div class="font-weight-large red--text title">
                                                                                        {{item.TarihBilgileri.SatisTarihi}}
                                                                                    </div>
                                                                                </v-list-tile-title>
                                                                                <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='Ia'">
                                                                                    <div class="font-weight-large grey--text caption">
                                                                                        İade Tarihi:
                                                                                        <span class="font-weight-large red--text caption">

                                                                                            {{item.TarihBilgileri.IadeTarihi}}
                                                                                        </span>
                                                                                    </div>
                                                                                </v-list-tile-sub-title>
                                                                                <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='V'">
                                                                                    <div class="font-weight-large grey--text caption ">
                                                                                        Void
                                                                                        Tarihi:<span class="font-weight-large red--text caption">
                                                                                            {{item.TarihBilgileri.IptalTarihi}}
                                                                                        </span>
                                                                                    </div>
                                                                                </v-list-tile-sub-title>
                                                                            </v-layout>
                                                                        </v-list-tile-content>
                                                                    </v-list-tile>
                                                                </v-card>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex class="hidden-md-and-up" xs2 sm2 md2>
                                                        </v-flex>

                                                        <v-flex xs12 sm4 md2>
                                                            <v-layout align-start="" fill-height="" row wrap>
                                                                <v-flex xs12 sm12 md12>
                                                                    <v-layout align-start="" row justify-start fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content style="'overflow=inherit';">
                                                                                    <v-list-tile-sub-title>
                                                                                        <div class="font-weight caption ">
                                                                                            Fatura
                                                                                            Tarihi:
                                                                                            {{item.FaturaBilgileri.FaturaTarihi}}
                                                                                        </div>
                                                                                    </v-list-tile-sub-title>

                                                                                    <v-list-tile-sub-title>
                                                                                        <div class="font-weight caption ">
                                                                                            Fatura No:
                                                                                            {{item.FaturaBilgileri.FaturaNo}}
                                                                                        </div>
                                                                                    </v-list-tile-sub-title>
                                                                                    <v-list-tile-sub-title>
                                                                                        <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Beklemede'" class="font-weight caption ">
                                                                                            <v-icon hide-details color="yellow" small="">
                                                                                                access_alarm
                                                                                            </v-icon>
                                                                                            {{item.FaturaBilgileri.FaturaDurumu}}
                                                                                        </div>

                                                                                        <div v-if="item.FaturaBilgileri.FaturaDurumu=='Alıcı Onayladı'" class="font-weight caption ">
                                                                                            <v-icon hide-details color="green" small="">
                                                                                                check_box
                                                                                            </v-icon>
                                                                                            {{item.FaturaBilgileri.FaturaDurumu}}
                                                                                        </div>

                                                                                        <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Gönderildi'" class="font-weight caption ">
                                                                                            <v-icon hide-details color="red" small="">
                                                                                                send
                                                                                            </v-icon>
                                                                                            {{item.FaturaBilgileri.FaturaDurumu}}
                                                                                        </div>

                                                                                    </v-list-tile-sub-title>

                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>

                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm4 md2>
                                                            <v-layout>

                                                                <v-flex xs12 sm6 md6>
                                                                    <v-layout align-start="" justify-start fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-sub-title>
                                                                                        <div class="font-weight caption ">
                                                                                            Bilet
                                                                                            Tutarı:
                                                                                        </div>
                                                                                    </v-list-tile-sub-title>
                                                                                    <v-list-tile-sub-title>
                                                                                        <div class="font-weight caption ">
                                                                                            Vergiler:
                                                                                        </div>
                                                                                    </v-list-tile-sub-title>
                                                                                    <v-list-tile-sub-title>
                                                                                        <div class="font-weight caption ">
                                                                                            Servis
                                                                                            Bedeli:
                                                                                        </div>
                                                                                    </v-list-tile-sub-title>
                                                                                    <v-list-tile-sub-title>
                                                                                        <div class="font-weight caption ">

                                                                                        </div>
                                                                                    </v-list-tile-sub-title>

                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs12 sm6 md6>
                                                                    <v-layout row justify-end="" fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-sub-title>
                                                                                        <v-layout align-center="" justify-end>
                                                                                            <div class="font-weight caption ">
                                                                                                {{item.TutarBilgileri.GosterilecekTutar | moneyformat}}
                                                                                                {{getparabirimi()}}
                                                                                            </div>
                                                                                        </v-layout>
                                                                                    </v-list-tile-sub-title>
                                                                                    <v-list-tile-sub-title>
                                                                                        <v-layout align-center="" justify-end="">
                                                                                            <div class="font-weight caption ">
                                                                                                {{item.TutarBilgileri.Vergiler}}
                                                                                                {{getparabirimi()}}
                                                                                            </div>
                                                                                        </v-layout>
                                                                                    </v-list-tile-sub-title>
                                                                                    <v-list-tile-sub-title>
                                                                                        <v-layout align-center="" justify-end="">
                                                                                            <div class="font-weight caption ">
                                                                                                {{item.TutarBilgileri.ServisBedeli}}
                                                                                                {{getparabirimi()}}
                                                                                            </div>
                                                                                        </v-layout>
                                                                                    </v-list-tile-sub-title>
                                                                                    <v-list-tile-sub-title>
                                                                                        <v-layout align-center="">
                                                                                            <div class="font-weight caption ">

                                                                                            </div>
                                                                                        </v-layout>
                                                                                    </v-list-tile-sub-title>
                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm4 md1>
                                                            <v-layout row align-center justify-end="" fill-height="">
                                                                <v-card flat="">
                                                                    <v-list-tile>
                                                                        <v-list-tile-content>
                                                                            <v-layout row wrap justify-end="">
                                                                                <v-list-tile-title>
                                                                                    <v-layout row wrap justify-center="">
                                                                                        Net Tutar
                                                                                    </v-layout>
                                                                                </v-list-tile-title>
                                                                                <v-list-tile-sub-title>
                                                                                    <v-layout row wrap justify-end="">
                                                                                        <div class="red--text subheading">
                                                                                            {{item.TutarBilgileri.NetTutar.NetTutar }}
                                                                                            {{getparabirimi()}}
                                                                                        </div>
                                                                                    </v-layout>

                                                                                </v-list-tile-sub-title>
                                                                                <v-list-tile-title>
                                                                                    <v-layout row wrap justify-center="">
                                                                                        <div class="font-weight green--text caption ">
                                                                                            {{item.OdemeBilgileri.SatisSekli}}
                                                                                        </div>
                                                                                    </v-layout>

                                                                                </v-list-tile-title>
                                                                            </v-layout>
                                                                        </v-list-tile-content>

                                                                    </v-list-tile>
                                                                </v-card>
                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex sm4 md1>
                                                            <v-layout row align-center justify-end="">
                                                                <v-card flat="">
                                                                    <v-list-tile>
                                                                        <v-list-tile-action>
                                                                            <v-layout align-center="" fill-height="" justify-end>
                                                                                <v-flex sm6 md6>
                                                                                    <a v-if="item.GenelBilgileri.Status!='V'" target="_blank" v-bind:href="'#/bilet/biletdetay/id?' + 'isl=get&hyolukod=' + item.GenelBilgileri.HavaYoluKodu + '&biletno=' + item.GenelBilgileri.BiletNo + '&ucustipi=' + item.GenelBilgileri.UcusTipi">
                                                                                        <v-btn icon>
                                                                                            <v-icon x-large="" color="grey">
                                                                                                search
                                                                                            </v-icon>
                                                                                        </v-btn>
                                                                                    </a>

                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </v-list-tile-action>
                                                                    </v-list-tile>
                                                                </v-card>
                                                            </v-layout>
                                                        </v-flex>

                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-card>
                                    </v-flex>
                                </v-layout>

                            </v-list>
                        </v-card>
                    </v-hover>
                </v-flex>

            </v-card>
        </v-flex>
    </v-layout>

    <template v-if="vmodelpagination">
        <div class="text-xs-center">
            <v-container>
                <v-layout justify-center>
                    <v-flex xs8>
                        <v-pagination :disabled="paginationDisabled" color="info" v-model="sayfalama" :length="pagenumber"></v-pagination>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
    </template>

    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
    </v-snackbar>

</div>
</template>

<script>
import auth from '../../../api/auth'
import kredikartcomp from "@/components/app/bilet/partpage/kredikartcomp.vue"
import logoo from '../../../assets/control'
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
import parainput from "@/components/app/customcomp/parainput.vue"
import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
import tarihim from "@/components/app/customcomp/tarihim.vue"
import helpers from "@/components/app/customcomp/helpers.js"
import loadingcomp from "@/components/app/customcomp/loadingcomp.vue"
import tarihinput from '@/components/app/customcomp/tarihim.vue';

export default {
    data() {

        return {
            loadingmesaj: 'Excel rapor hazırlama ',
            loadingdialog: false,
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },
            servisclass: {
                SirketKodu: '',
                Cari: {
                    Kod: null
                },
                Parkurlar: {
                    Parkur1: '',
                    Parkur2: '',
                    Parkur3: '',
                    Parkur4: '',
                    Parkur5: '',
                },
                Hat: '',
                DefaultKontrol: false
            },
            filtrevarmi: false,
            searchIcon: 'search',
            aramatipi: [{
                    value: '-',
                    text: 'Bilet Numarası'
                },
                {
                    value: '-',
                    text: 'Yolcu Adı'
                },
                {
                    value: '-',
                    text: 'Pnr No'
                },
                {
                    value: '-',
                    text: 'Cari Kodu'
                },
                {
                    value: '-',
                    text: 'Cari Ünvanı'
                },
                {
                    value: '-',
                    text: 'Kesen Kişi'
                },
                {
                    value: '-',
                    text: 'Rezervasyon Alan'
                },
                {
                    value: '-',
                    text: 'Rezervasyon Veren'
                },
                {
                    value: '-',
                    text: 'Uçuş Numarası'
                },
                {
                    value: '-',
                    text: 'Bilet Tel'
                },
                {
                    value: '-',
                    text: 'E-mail'
                }, {
                    value: '-',
                    text: 'Vergi Numarası'
                }, {
                    value: '-',
                    text: ' Tc Kimlik Numarası'
                }, {
                    value: '-',
                    text: 'Bilet Net Tutarı'
                }
            ],

            paginationDisabled: false,

            filtreUyarimesaj: false,

            caridegistirBtn: false,
            filtrecaridegistirView: false,
            cariOnay: false,
            bilettipisatisOnay: false,
            faturatipifaturalanmamislarOnay: false,

            filtregecicicaridegistirView: false,
            tekhattpiiOnay: false,
            gecicarilerOnay: null,
            gecicicaridegistirBtn: false,

            filtrevoidyapView: false,
            voidyapBtn: false,

            filtreiadekontrolView: false,
            bilettipiiadeOnay: false,
            dekontbasOnay: false,
            giderpusulaOnay: false,
            iadefaturagelmeyenOnay: false,

            bilettipiiadeOnay: false,
            dekontbasilanOnay: false,
            iadebelgedekontOnay: false,
            iadefaturasigelmeyenOnay: false,
            iadeekleBtn: false,

            filtrealisfaturaView: false,
            bilettipisatisiadeOnay: false,
            acentefatnoOnay: false,
            alisfaturanoBtn: false,

            iadefattarih: null,
            faturaBelgeNo: null,
            faturaIadeBelgeNo: null,
            bankaposshow: false,
            servisposshow: false,
            bankapositems: [],
            taksitsayi: [],
            taksitsayiservis: [],
            kredikartshow: false,

            karttipi: [{
                    id: 'M',
                    text: 'Master Card'
                },
                {
                    id: 'VI',
                    text: 'VISA'
                },
                {
                    id: 'A',
                    text: 'American Express'
                },
            ],
            sonkullanimAy: [{
                    id: '01',
                    text: '1'
                },
                {
                    id: '02',
                    text: '2'
                },
                {
                    id: '03',
                    text: '3'
                },
                {
                    id: '04',
                    text: '4'
                },
                {
                    id: '05',
                    text: '5'
                },
                {
                    id: '06',
                    text: '6'
                },
                {
                    id: '07',
                    text: '7'
                },
                {
                    id: '08',
                    text: '8'
                },
                {
                    id: '09',
                    text: '9'
                },
                {
                    id: '10',
                    text: '10'
                },
                {
                    id: '11',
                    text: '11'
                },
                {
                    id: '12',
                    text: '12'
                }
            ],
            sonkullanimYil: [
                '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016',
                '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
                '2029', '2030'
            ],
            dialogmesajgecici: null,
            gecicicaridialogsor: false,
            geciciyenicari: null,
            doviztipi: [],
            satissekliitem: [{
                text: 'K-Kredili',
                value: 'K'
            }, {
                text: 'P-Peşin',
                value: 'P'
            }, {
                text: 'R-Kartlı',
                value: 'R'
            }, {
                text: 'C-Kartlı',
                value: 'C'
            }, {
                text: 'F-Kredi Kartlı',
                value: 'F'
            }],
            datenull:null,
            filtreuyari: '',
            filtrealert: false,
            voiddate: null,
            statecarigecic: [],
            loadinggecici: false,
            yenicarigecici: null,
            yenicarigecicisearch: null,
            gecicicaridialog: false,
            nereden: 0,
            aramayapildi: false,
            kayitadet: 50,
            siralamatipi: 'SalesDate',
            kayitvarmi: false,
            caridialog: false,
            dialogmesaj: null,
            yedekListInput: null,
            tumunuseckaldir: false,
            statecariyeni: [],
            yenicari: null,
            yenicarisearch: null,
            dialogcarikoddegistir: false,
            secilenkayitlar: [],
            secilenkayitlaryedek: [],

            bankapositems: [],
            itemsparkur: [],
            itemsyon: [{
                    text: 'Hepsi',
                    value: '0'
                },
                {
                    text: 'İç Hat',
                    value: 'I'
                }, {
                    text: 'Dış',
                    value: 'D'
                }
            ],
            itemstip: [{
                text: 'Satış',
                value: 'S'
            }, {
                text: 'Iade',
                value: 'I'
            }],
            RezTutarEtiket: 'Reserve Tutar',
            itemsairlinelist: [],
            ListInputYedek: [],
            dialogtype: null,

            ListInput: {
                SirketKodu: null,
                BaslangicTarihi: null,
                BitisTarihi: null,
                Carikod: null,
                HavaYoluKodu: null,
                FormNo: null,
                BiletNo: null,
                TextSearch: null,
                Paging: {
                    SayfaNo: null,
                    VeriAdet: 50,
                    SiralamaTip: 0
                },
                Filtreler: {
                    CariKod: null,
                    Havayollari: [],
                    Parkurlar: [],
                    HatTipi: [], // I : iç hat, D: Dış hat, B: Bsp
                    BiletTipi: 'S', // S: Satış, I: Iade, V : Void
                    Ucus1: null,
                    Ucus2: null,
                    KesenKisi: null,
                    PosKod: null,
                    DekontBas: false,
                    KrediKartNo: null,
                    GiderPusulasi: 0, // 0: seçim yok, 1 : basılmış, 2 : basılmamış
                    AcentaFatNo: 0, // 0 : seçim yok, 1 : fatura olan, 2 : fatura olmayan
                    IadeFatura: false,
                    GeciciCari: 0, // 0 : hepsi, 1 : geci haric, 2 : sadece gecici
                    FaturaStatus: 0, // 0 : hepsi, 1 : faturalanmamışlar, 2 : faturalanmışlar
                    FaturaTarihi: null,
                    FaturaNo: null,
                    FaturaSeri: null,
                    BaslangicTutar: 0,
                    BitisTutar: 0,
                    TutarTip: 0 // 0 : NetTutar, 1 : Bilet Tutar, 2 : Servis Tutar, 3 : Iskonto Tutar
                }
            },
            GeciciCari: {
                KesenKisi: null,
                Referans: null,
                Masraf: null,
                RezervasyonVeren: null,
                RezervasyonAlan: null,
                SatisSekli: 'K',
                KrediKartNo: null,
                KKCins: null,
                KKAy: null,
                KKYil: null,
                ServisTutar: 0,
                DigerServisTutar: 0,
                IskontoTutar: 0,
                HYTutar: 0,
                PosKod: null,
                TaksitKod: null,
                ReserveTutar: 0,
                ServisPosKod: null,
                ServisTaksitKod: null,
                DovizTip: null,
                BolumKodu: null,
                GSM: null,
                DateofRes: null, //date
                AnalizKodu: null,
                AnalizTutar: 0,
                AnalizKodu1: null,
                AnalizTutar1: 0,
            },

            Havayolu: {
                HavaYoluKodu: null,
                FormNo: null,
                HavaYoluAdi: null
                //devam eden class
            },
            searchliste: null,
            listegorunum: true,
            gorunumtipi: 'list',
            tablegorunum: false,
            kayitsayisivmodel: 50,
            kayitsayisi: [{
                text: '50',
                value: 50
            }, {
                text: '100',
                value: 100
            }],
            vmodelpagination: false,
            siralamavmodel: 0,
            siralamatipiitems: [{
                text: 'Tarihe Göre Artan',
                value: 'SalesDate'
            }, {
                text: 'Tarihe Göre Azalan',
                value: 'SalesDateDesc'
            }, {
                text: 'Bilet No Artan',
                value: 'TicketNumber'
            }, {
                text: 'Bilet No Azalan',
                value: 'TicketNumberDesc'
            }, {
                text: 'Fatura Tarihi Artan',
                value: 'InvoiceDate'
            }, {
                text: 'Fatura Tarihi Azalan',
                value: 'InvoiceDateDesc'
            }, {
                text: 'Cari Kodu Artan',
                value: 'CustomerCode'
            }, {
                text: 'Cari Kodu Azalan',
                value: 'CustomerCodeDesc'
            }, {
                text: 'Fiyat Artan',
                value: 'Price'
            }, {
                text: 'Fiyat Azalan',
                value: 'PriceDesc'
            }],

            recordcount: '',
            filtreticket: [],
            indexsayisi: 10,
            pagenumber: 1,
            sayfalama: 1,
            search1: '',
            headers: [{
                    text: 'HY Kodu',
                    value: 'GenelBilgileri.HavaYoluKodu'
                },
                {
                    text: 'Bilet No ',
                    value: 'GenelBilgileri.BiletNo',
                },
                {
                    text: 'Tip',
                    value: 'GenelBilgileri.UcusTipi'
                },
                {
                    text: 'Durum',
                    value: 'GenelBilgileri.Status'
                },
                {
                    text: 'Müsteri Kodu',
                    value: 'GenelBilgileri.MusteriKodu.Kod'
                },
                {
                    text: 'Fatura Kayıtlı',
                    value: 'GenelBilgileri.MusteriKodu.EFaturaKayitliList'
                },
                {
                    text: 'Fatura Tip',
                    value: 'GenelBilgileri.MusteriKodu.FaturaTip'
                },
                {
                    text: 'Fatura Seri',
                    value: 'FaturaBilgileri.FaturaSeri'
                },
                {
                    text: 'Fatura No',
                    value: 'FaturaBilgileri.FaturaNo'
                },
                {
                    text: 'Satış Tip',
                    value: 'OdemeBilgileri.KrediKartBilgi.KrediKartTip'
                },
                {
                    text: 'Satış Tarihi',
                    value: 'TarihBilgileri.SatisTarihi'
                },
                {
                    text: 'Fatura Tarihi',
                    value: 'FaturaBilgileri.FaturaTarihi'
                },
                {
                    text: 'Net Tutar',
                    value: 'TutarBilgileri.NetTutar.NetTutar'
                },
                {
                    text: 'Satış Tutarı',
                    value: 'TutarBilgileri.Tutar.Tutar'
                },
                {
                    text: 'İade/Void Tarihi',
                    value: 'TarihBilgileri.IadeTarihi'
                },
                {
                    text: 'İade Tutarı',
                    value: 'Id'
                },
                {
                    text: 'Ceza',
                    value: 'TutarBilgileri.CezaTutar.CezaTutar'
                },
                {
                    text: 'Ex Bilet No',
                    value: 'GenelBilgileri.ExBiletNo'
                },
                {
                    text: 'Acente',
                    value: 'GenelBilgileri.Acente'
                },
                {
                    text: 'KK Tip',
                    value: 'OdemeBilgileri.KrediKartBilgi.KrediKartTip'
                },
                {
                    text: 'Servis',
                    value: 'TutarBilgileri.ServisTutar.ServisTutar'
                }
            ],
            value: null,
            caridegeri: null,
            dialogfiltre: false,
            loading: false,
            statecari: [],
            searchcari: '',
            renk1: 'info',
            date: null,
            menu: false,
            modal: false,
            dateFormatted: '',
            date2: null,
            menu2: false,
            dateFormatted2: '',
            modal2: false,
            harekettipi: '',
            items: [],
            itemsticket: [],

            StartDate: null,
            EndDate: null,
            load: false,
            load1: true,
            dialogmessage: '',
            dialog: false,
            progress: false,
            valid: true,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            text1: '',
            tooltip: false,
            el: null,

            //  tooltiptutar: false,
            // eltutar: null,
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    methods: {
        getTicketReportExcel() {
            if (this.$refs.formbiletrapor.validate()) {
                this.loadingdialog = true
                var hatTipi =0;
                if (this.ListInput.HatTipi == 'I') {
                    hatTipi = 1
                } else if (this.ListInput.HatTipi == 'D') {
                    hatTipi =2;
                }
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var params = {
                    SirketKodu: credentials.SirketKodu,
                    BaslangicTarih: this.date,
                    BitisTarih: this.date2,
                    FaturaTarihi: this.ListInput.Filtreler.FaturaTarihi,
                    FaturaSeri: null,
                    FaturaNo: this.ListInput.Filtreler.FaturaNo,
                    CariKod: this.ListInput.Filtreler.CariKod,
                    HatTipi: hatTipi,
                    FaturaStatus: this.ListInput.Filtreler.FaturaStatus,
                    GeciciStatus: this.ListInput.Filtreler.GeciciStatus,
                }

                this.$http
                    .post(auth.API_URL + "api/Dot9/TicketReportExcel", params, {
                        headers: {
                            Authorization: "Bearer " + auth.getAuthHeader()
                        },
                        responseType: "arraybuffer"
                    }).then((response) => {
                        this.progress = false
                        this.load1 = true
                        var blob = new Blob([response.data], {
                            type: 'application/xlsx'
                        });
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "BiletRapor.xlsx";
                        link.click();
                        this.loadingdialog = false

                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                            this.progress = false
                            this.load1 = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                            this.progress = false
                            this.load1 = true
                        }
                    })
            }
        },
        getTutarBilgileri(val) {

            var toplam = parseFloat(val.Tutar.Tutar) + parseFloat(val.ReserveTutar.ReserveTutar) + parseFloat(val.DigerServisTutar.DigerServisTutar)
            return toplam
        },
        getparabirimi() {
            return helpers.getparabirimi()
        },
        secenekleritemizle() {
            this.filtrecaridegistirView = false
            this.bilettipisatisOnay = false
            this.faturatipifaturalanmamislarOnay = false

            this.filtregecicicaridegistirView = false
            this.tekhattpiiOnay = false
            this.gecicarilerOnay = false

            this.filtrevoidyapView = false
            this.filtreiadekontrolView = false
            this.bilettipiiadeOnay = false
            this.cariOnay = false
            this.dekontbasOnay = false
            this.giderpusulaOnay = false
            this.iadefaturagelmeyenOnay = false

            this.filtrealisfaturaView = false
            this.bilettipisatisiadeOnay = false
            this.acentefatnoOnay = false

        },
        yenikayit() {

            var url = '#/bilet/yeni/id?isl=yeni';

            window.open(url, '_self')

        },
        cariservisgetir() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.servisclass.Cari.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
            this.servisclass.SirketKodu = credentials.SirketKodu
            this.servisclass.Hat = this.Bilet.GenelBilgileri.UcusTipi
            this.servisclass.Parkurlar.Parkur1 = this.Bilet.GenelBilgileri.Parkurlar.Parkur1
            this.servisclass.Parkurlar.Parkur2 = this.Bilet.GenelBilgileri.Parkurlar.Parkur2
            this.servisclass.Parkurlar.Parkur3 = this.Bilet.GenelBilgileri.Parkurlar.Parkur3
            this.servisclass.Parkurlar.Parkur4 = this.Bilet.GenelBilgileri.Parkurlar.Parkur4
            this.servisclass.Parkurlar.Parkur5 = this.Bilet.GenelBilgileri.Parkurlar.Parkur5
            this.servisclass.DefaultKontrol = true

            var params1 = this.servisclass

            this.$http.post(auth.API_URL + 'api/TicketDefinitons/ServiceCodeList', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                if (response.body.length != 0) {

                    this.Bilet.TanimBilgileri.ServisKod = response.body[0].Kod
                    var params = {
                        HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                        SirketKodu: credentials.SirketKodu,
                        ServisKodBilgi: response.body[0],
                        KurTarih: this.Bilet.TarihBilgileri.SatisTarihi,
                        TutarBilgi: {
                            ServisTutar: this.Bilet.TutarBilgileri.ServisTutar.ServisTutar,
                            BiletTutar: this.Bilet.TutarBilgileri.Tutar.Tutar,
                            VergiTutar: this.Bilet.TutarBilgileri.PtaTutar.PtaTutar + this.Bilet
                                .TutarBilgileri.AlanVergiTutar
                                .AlanVergitutar +
                                this.Bilet.TutarBilgileri.YFFTutar.YFFTutar // mco + alan + ceza + yff
                        }
                    }

                    this.$http.post(auth.API_URL + 'api/Helpers/GetServiceCodePrice', params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                        this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = response.body
                            .IskontoTutar
                        this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = response.body
                            .ServisTutar
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-GetServiceCodePrice'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-GetServiceCodePrice'
                            this.snackbar = true
                        }
                    })

                } else {

                }

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

        },

        biletarasearch(a) {
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false, this.searchliste)
        },
        biletara(a) {
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false, a)
        },
        deneme() {
            this.secilenkayitlar = []
            this.secilenkayitlar = this.secilenkayitlaryedek

        },
        alisFaturaNoisle() {
            if (this.$refs.formalisfatura.validate()) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var biletlistesi = [];

                this.secilenkayitlar.forEach(element => {
                    var yenikayit = {
                        SirketKodu: credentials.SirketKodu,
                        HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                        Formno: element.GenelBilgileri.Formno,
                        BiletNo: element.GenelBilgileri.BiletNo,
                        UcusTipi: element.GenelBilgileri.UcusTipi,
                    }
                    biletlistesi.push(yenikayit)

                });

                var params = {
                    Biletler: biletlistesi,
                    AlisFaturaTarih: this.iadefattarih,
                    AlisFaturaNo: this.faturaBelgeNo
                }

                this.$http.post(auth.API_URL + 'api/Ticket/TicketBuyingInvoiceSave', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.text1 = response.body.ResponseMessage;
                    this.snackbar = true;

                    if (response.body.Status == true) {
                        this.caridialog = false;
                        this.secilenkayitlar = [];
                        this.BiletListele(1, this.siralamatipi, this.kayitadet, true)

                    }

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.progress = false

                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.progress = false

                        this.snackbar = true
                    }
                })

            }

        },
        alisFaturaNokontrol() {

            this.secenekleritemizle();

            if ((this.ListInput.Filtreler.BiletTipi == 'S' || this.ListInput.Filtreler.BiletTipi == 'I') &&
                this.ListInput.Filtreler.AcentaFatNo == 2) {

                this.caridegistirBtn = false;
                this.voidyapBtn = false;
                this.gecicicaridegistirBtn = false
                this.iadeekleBtn = false
                this.alisfaturanoBtn = true

                if (this.secilenkayitlar.length > 0) {
                    this.caridialog = true;
                    this.iadetarih = helpers.getDateNow();
                    this.dialogtype = 'alisfatura';
                    this.dialogmesaj = " adet kayıta alış fatura no işlemek istediğinize emin misiniz?";

                } else {
                    this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
                    this.snackbar = true;
                }
            } else {
                this.filtrele();
                this.filtreUyarimesaj = true
                this.filtrealisfaturaView = true
                this.filtrecaridegistirView == false
                this.filtregecicicaridegistirView == false
                this.filtrevoidyapView == false
                this.filtreiadekontrolView == false

                if (this.ListInput.Filtreler.BiletTipi == 'S' || this.ListInput.Filtreler.BiletTipi == 'I') {
                    this.bilettipisatisiadeOnay = true
                } else {
                    this.bilettipisatisiadeOnay = false
                }
                this.acentefatnoOnay = true

                this.ListInput.Filtreler.AcentaFatNo = 2
            }
        },

        gecicicarikontrol() {

            this.secenekleritemizle();

            if (this.ListInput.Filtreler.BiletTipi == 'S' && this.ListInput.Filtreler.FaturaStatus == 1 &&
                this
                .ListInput.Filtreler.GeciciCari == 2 && this.ListInput.Filtreler.HatTipi != null) {

                this.caridegistirBtn = false;
                this.voidyapBtn = false;
                this.gecicicaridegistirBtn = true
                this.iadeekleBtn = false
                this.alisfaturanoBtn = false

                if (this.secilenkayitlar.length > 0) {

                    this.gecicicaridialog = true;

                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                    var params1 = {
                        CompanyCode: credentials.SirketKodu
                    }

                    this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params1, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.RezTutarEtiket = response.body
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-class'
                            this.progress = false
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-class'
                            this.progress = false
                            this.snackbar = true
                        }
                    })

                    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.doviztipi = response.body
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-Döviz'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-Döviz'
                            this.snackbar = true
                        }
                    })

                    this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.bankapositems = response.body
                        this.progress = false
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-bankpos'
                            this.progress = false
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-bankpos'
                            this.snackbar = true
                            this.progress = false
                        }
                    })

                } else {
                    this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
                    this.snackbar = true;
                }
            } else {
                this.filtrele();

                this.filtreUyarimesaj = true
                this.filtregecicicaridegistirView = true
                this.filtrecaridegistirView == false

                this.filtrevoidyapView == false
                this.filtreiadekontrolView == false
                this.filtrealisfaturaView == false

                this.bilettipisatisOnay = true
                this.faturatipifaturalanmamislarOnay = true
                this.tekhattpiiOnay = false
                this.gecicarilerOnay = true

                this.ListInput.Filtreler.BiletTipi = 'S'
                this.ListInput.Filtreler.FaturaStatus = 1
                this.ListInput.Filtreler.GeciciCari = 2
            }
        },

        iadekontrol() {
            this.secenekleritemizle();

            if (this.ListInput.Filtreler.BiletTipi == 'I' && this.ListInput.Filtreler.DekontBas == true &&
                this
                .ListInput.Filtreler.CariKod != null && this.ListInput.Filtreler.GiderPusulasi == 2 && this
                .ListInput.Filtreler.IadeFatura == true) {

                this.caridegistirBtn = false;
                this.voidyapBtn = false;
                this.gecicicaridegistirBtn = false
                this.iadeekleBtn = true
                this.alisfaturanoBtn = false

                if (this.secilenkayitlar.length > 0) {
                    this.caridialog = true;
                    this.iadetarih = helpers.getDateNow();
                    this.dialogtype = 'iade';
                    this.dialogmesaj =
                        " adet gelen iade kaydına Fatura No işlemek istediğinize emin misiniz?";

                } else {
                    this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
                    this.snackbar = true;
                }
            } else {
                this.filtrele();

                this.filtreUyarimesaj = true
                this.filtreiadekontrolView = true
                this.filtrecaridegistirView == false
                this.filtregecicicaridegistirView == false
                this.filtrevoidyapView == false
                this.filtrealisfaturaView == false

                this.bilettipiiadeOnay = true

                if (this.ListInput.Filtreler.CariKod == null) {
                    this.cariOnay = false

                } else {
                    this.cariOnay = true

                }

                this.dekontbasOnay = true
                this.giderpusulaOnay = true
                this.iadefaturagelmeyenOnay = true
                this.ListInput.Filtreler.BiletTipi = 'I'
                this.ListInput.Filtreler.DekontBas = true
                this.ListInput.Filtreler.GiderPusulasi = 2
                this.ListInput.Filtreler.IadeFatura = true

            }
        },

        carikontrol() {
            this.secenekleritemizle();

            if (this.ListInput.Filtreler.BiletTipi == 'S' && this.ListInput.Filtreler.FaturaStatus == 1 &&
                this
                .ListInput.Filtreler.CariKod != null && this.ListInput.Filtreler.CariKod != '') {
                this.caridegistirBtn = true;
                this.voidyapBtn = false;
                this.gecicicaridegistirBtn = false
                this.iadeekleBtn = false
                this.alisfaturanoBtn = false

                if (this.secilenkayitlar.length > 0) {
                    this.caridialog = true;
                    this.dialogtype = 'cari';
                    this.dialogmesaj = " adet kaydın cari bilgisini değiştirmek istediğinize emin misiniz?";
                } else {
                    this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
                    this.snackbar = true;
                }
            } else {
                this.filtrele();
                this.filtreUyarimesaj = true
                this.filtrecaridegistirView = true
                this.filtregecicicaridegistirView == false
                this.filtrevoidyapView == false
                this.filtreiadekontrolView == false
                this.filtrealisfaturaView == false
                this.bilettipisatisOnay = true
                this.faturatipifaturalanmamislarOnay = true
                this.ListInput.Filtreler.BiletTipi = 'S'
                this.ListInput.Filtreler.FaturaStatus = 1

            }
        },
        voidkontrol() {
            this.secenekleritemizle();

            if (this.ListInput.Filtreler.BiletTipi == 'S' && this.ListInput.Filtreler.FaturaStatus == 1) {

                this.caridegistirBtn = false;
                this.voidyapBtn = true;
                this.gecicicaridegistirBtn = false
                this.iadeekleBtn = false
                this.alisfaturanoBtn = false

                if (this.secilenkayitlar.length > 0) {
                    this.caridialog = true;
                    this.dialogtype = 'void';
                    this.dialogmesaj = " adet kaydı void yapmak istediğinize emin misiniz?";
                    this.voiddate = helpers.getDateNow();

                } else {
                    this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
                    this.snackbar = true;
                }
            } else {
                this.filtrele();
                this.filtreUyarimesaj = true
                this.filtrevoidyapView = true
                this.filtrecaridegistirView == false
                this.filtregecicicaridegistirView == false
                this.filtreiadekontrolView == false
                this.filtrealisfaturaView == false

                this.bilettipisatisOnay = true
                this.faturatipifaturalanmamislarOnay = true
                this.ListInput.Filtreler.BiletTipi = 'S'
                this.ListInput.Filtreler.FaturaStatus = 1
            }

        },
        taksitgetir(v) {

            var tumliste = []
            tumliste = this.bankapositems

            tumliste.forEach(element => {

                if (element.PosKodu == v) {

                    this.taksitsayi = []
                    this.taksitsayi = element.Taksitler

                }
            });

        },
        taksitgetirservis(v) {

            var tumliste = []
            tumliste = this.bankapositems

            tumliste.forEach(element => {

                if (element.PosKodu == v) {

                    this.taksitsayiservis = []
                    this.taksitsayiservis = element.Taksitler
                }
            });
        },
        gecicicariac() {

            this.gecicicaridialog = true;

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var params1 = {
                CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.RezTutarEtiket = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-class'
                    this.progress = false
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-class'
                    this.progress = false
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/currency/List', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.doviztipi = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Döviz'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-Döviz'
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.bankapositems = response.body
                this.progress = false
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-bankpos'
                    this.progress = false
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-bankpos'
                    this.snackbar = true
                    this.progress = false
                }
            })

        },
        carisor() {

            if (this.yenicari != null) {
                if (this.secilenkayitlar.length > 0) {

                    this.caridialog = true;
                    this.dialogtype = 'cari';
                    this.dialogmesaj = " adet kaydın carisini değiştirmek istediğinize emin misiniz?";

                } else {
                    this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
                    this.snackbar = true;
                }

            } else {
                this.text1 = 'Lütfen Cari Kod Seçimi Yapınız'
                this.snackbar = true;
            }
        },
        gecicicarisor() {

            if (this.geciciyenicari != null) {
                if (this.secilenkayitlar.length > 0) {
                    this.gecicicaridialogsor = true;
                    this.dialogmesajgecici =
                        " adet kaydın geçici cari bilgilerini değiştirmek istediğinize emin misiniz?";
                } else {
                    this.text1 =
                        'Bilet Seçimi Yapmadınız. işleminize devam edebilmek için bilet seçmeniz gerekmektedir...'
                    this.snackbar = true;
                }

            } else {
                this.text1 = 'Lütfen Cari Kod Seçimi Yapınız'
                this.snackbar = true;
            }
        },
        getImgUrl(img) {
            return logoo.logoControl(img);
        },
        denemem() {
            this.secilenkayitlar = []
        },
        BiletListele: BiletListele,
        filtrekayit: filtrekayit,
        filtreiptal: filtreiptal,
        carigetir: carigetir,
        git: git,
        gitliste: gitliste,
        sayfala: sayfala,
        tarihkontrol: tarihkontrol,
        filtrele: filtrele,
        odemeseklikontrol: odemeseklikontrol,
        vergihesapla: vergihesapla,
        servishesapla: servishesapla,
        carikoddegistir: carikoddegistir,
        carigetiryeni: carigetiryeni,
        carigetirgecici: carigetirgecici,
        gecicicarikoddegistir: gecicicarikoddegistir,
        topluvoidyap: topluvoidyap,
        geleniadefaturisle: geleniadefaturisle
    },
    beforeMount: beforeMount,

    mounted() {
        this.el = this.$refs.fab.$el
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
         this.date = helpers.getDateNow()
         this.date2 = helpers.getDateNow()

        this.BiletListele(1,'SalesDate',50,false);
        // this.progress = true
        // this.load = true
        // this.load1 = false
       

       
        // console.log("HOP" + credentials.CariBilgi.Kod)
        // this.ListInput.Filtreler.Carikod = credentials.CariBilgi.Kod
        // this.ListInput.SirketKodu = credentials.CariBilgi.SirketKodu
        // this.ListInput.BaslangicTarihi = this.date
        // this.ListInput.BitisTarihi = this.date2
        // this.ListInput.Paging.SayfaNo = 1
        // this.ListInput.Paging.VeriAdet = 50
        // this.ListInput.Paging.SiralamaTip = 'SalesDate'

        // this.ListInputYedek = this.ListInput;

        // var Params = this.ListInput;
        // this.yedekListInput = this.ListInput;
        // this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
        //     headers: {
        //         'Authorization': 'Bearer ' + auth.getAuthHeader()
        //     }
        // }).then((response) => {
        //     if (response.body.length > 0) {
        //         // this.itemsticket = response.body

        //         this.tumunuseckaldir = false;
        //         this.secilenkayitlar = [];
        //         this.aramayapildi = true;

        //         if (response.body.length > 0) {
        //             this.kayitvarmi = true;
        //             this.pagenumber = response.body[0].TotalPage;
        //             this.vmodelpagination = true;
        //             this.recordcount = 'Toplam ' + response.body[0].TotalCount +
        //                 ' kayıt listelendi';
        //             var editdizi = [];

        //             response.body.forEach(element => {

        //                 var yenikayit = [];

        //                 yenikayit.FaturaBilgileri = element.FaturaBilgileri;
        //                 yenikayit.GenelBilgileri = element.GenelBilgileri;

        //                 var tarih = {
        //                     SatisTarihi: tarihkontrol(element.TarihBilgileri
        //                         .SatisTarihi),
        //                     IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
        //                     IptalTarihi: tarihkontrol(element.TarihBilgileri
        //                         .IptalTarihi)
        //                 }

        //                 yenikayit.TarihBilgileri = tarih;

        //                 var fatura = {
        //                     FaturaNo: element.FaturaBilgileri.EfaturaBilgileri.FaturaNo,
        //                     FaturaTarihi: tarihkontrol(element.FaturaBilgileri
        //                         .EfaturaBilgileri
        //                         .GercekFaturaTarihi),
        //                     FaturaDurumu: element.FaturaBilgileri.EfaturaBilgileri
        //                         .FaturaDurumu
        //                 }

        //                 yenikayit.FaturaBilgileri = fatura;

        //                 var TutarBilgileri = {
        //                     AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
        //                     CezaTutar: {
        //                         CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
        //                     },
        //                     CharterTutar: element.TutarBilgileri.CharterTutar,
        //                     DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
        //                     IskontoTutar: element.TutarBilgileri.IskontoTutar,
        //                     KaTutar: element.TutarBilgileri.KaTutar,
        //                     NetTutar: {
        //                         NetTutar: element.TutarBilgileri.NetTutar.NetTutar
        //                             .toFixed(
        //                                 2)
        //                             .replace(
        //                                 /(\d)(?=(\d{3})+\.)/g, '$1,')
        //                     },
        //                     PtaTutar: element.TutarBilgileri.PtaTutar,
        //                     ReserveTutar: element.TutarBilgileri.ReserveTutar,
        //                     ServisTutar: {
        //                         ServisTutar: element.TutarBilgileri.ServisTutar
        //                             .ServisTutar
        //                     },
        //                     TaxTutar: element.TutarBilgileri.TaxTutar,
        //                     Tutar: {
        //                         Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2)
        //                             .replace(
        //                                 /(\d)(?=(\d{3})+\.)/g, '$1,')
        //                     },
        //                     YFFTutar: element.TutarBilgileri.YFFTutar,
        //                     Vergiler: vergihesapla(element.TutarBilgileri),
        //                     ServisBedeli: servishesapla(element.TutarBilgileri),
        //                     GosterilecekTutar: this.getTutarBilgileri(element.TutarBilgileri)
        //                 }

        //                 yenikayit.TutarBilgileri = TutarBilgileri;
        //                 var OdemeBilgileri = {
        //                     SatisSekli: odemeseklikontrol(element.OdemeBilgileri
        //                         .SatisSekli)
        //                 }
        //                 yenikayit.OdemeBilgileri = OdemeBilgileri;
        //                 editdizi.push(yenikayit)
        //             });

        //             this.filtreticket = editdizi;
        //         }

        //     } else {
        //         this.text1 = 'Kayıt Bulunamadı'
        //         this.snackbar = true
        //     }

        //     this.progress = false
        //     this.load1 = true
        //     this.load = false

        // }, (response) => {
        //     if (response.status === 0) {
        //         this.text1 = 'Service Unavailable'
        //         this.snackbar = true
        //         this.load1 = true
        //         this.progress = false
        //     } else {
        //         this.text1 = 'Service Unavailable'
        //         this.snackbar = true
        //         this.load1 = true
        //         this.progress = false
        //     }
        // })

    },
    components: {
        kredikartcomp,
        referansmerkezicomp,
        masrafmerkezicomp,
        analizcomp,
        parainput,
        bolumcomp,
        tarihim,
        loadingcomp,
              tarihinput

    },
    watch: {
        'ListInput.Filtreler.FaturaNo': function (v) {
            if (v.length == 1) {
                if (v == 0) {
                    this.ListInput.Filtreler.FaturaNo = []
                }
            }
        },
        searchliste: function (val) {

            if (val.length > 0) {
                this.searchIcon = "send"
            } else {
                this.searchIcon = "search"

            }
        },
        tumunuseckaldir(valsec) {

            if (valsec == true && this.aramayapildi == true) {

                this.yedekListInput.Paging.SayfaNo = 0
                this.yedekListInput.Paging.VeriAdet = null
                this.yedekListInput.Paging.SiralamaTip = null
               
                var Params = this.yedekListInput;
                this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    var editdizi = []

                    response.body.forEach(element => {

                        var yenikayit = [];

                        yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                        yenikayit.GenelBilgileri = element.GenelBilgileri;

                        var tarih = {
                            SatisTarihi: tarihkontrol(element.TarihBilgileri
                                .SatisTarihi),
                            IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
                            IptalTarihi: tarihkontrol(element.TarihBilgileri
                                .IptalTarihi)
                        }

                        yenikayit.TarihBilgileri = tarih;

                        var fatura = {
                            FaturaNo: element.FaturaBilgileri.EfaturaBilgileri.FaturaNo,
                            FaturaTarihi: tarihkontrol(element.FaturaBilgileri
                                .EfaturaBilgileri
                                .GercekFaturaTarihi),
                            FaturaDurumu: element.FaturaBilgileri.EfaturaBilgileri
                                .FaturaDurumu
                        }

                        yenikayit.FaturaBilgileri = fatura;

                        var TutarBilgileri = {
                            AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
                            CezaTutar: {
                                CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
                            },
                            CharterTutar: element.TutarBilgileri.CharterTutar,
                            DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
                            IskontoTutar: element.TutarBilgileri.IskontoTutar,
                            KaTutar: element.TutarBilgileri.KaTutar,
                            NetTutar: {
                                NetTutar: element.TutarBilgileri.NetTutar.NetTutar
                                    .toFixed(2)
                                    .replace(
                                        /(\d)(?=(\d{3})+\.)/g, '$1,')
                            },
                            PtaTutar: element.TutarBilgileri.PtaTutar,
                            ReserveTutar: element.TutarBilgileri.ReserveTutar,
                            ServisTutar: {
                                ServisTutar: element.TutarBilgileri.ServisTutar
                                    .ServisTutar
                            },
                            TaxTutar: element.TutarBilgileri.TaxTutar,
                            Tutar: {
                                Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2)
                                    .replace(
                                        /(\d)(?=(\d{3})+\.)/g, '$1,')
                            },
                            YFFTutar: element.TutarBilgileri.YFFTutar,
                            Vergiler: vergihesapla(element.TutarBilgileri),
                            ServisBedeli: servishesapla(element.TutarBilgileri)
                        }

                        yenikayit.TutarBilgileri = TutarBilgileri;
                        var OdemeBilgileri = {
                            SatisSekli: odemeseklikontrol(element.OdemeBilgileri
                                .SatisSekli)
                        }
                        yenikayit.OdemeBilgileri = OdemeBilgileri;
                        editdizi.push(yenikayit)
                    });

                    //   this.filtreticket = editdizi;

                    this.secilenkayitlar = editdizi;
                    this.secilenkayitlaryedek = editdizi;
                    this.aramayapildi = false;

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Hata Oluştu'
                        this.snackbar = true
                        this.load1 = true
                        this.progress = false
                    } else {
                        this.text1 = 'Hata Oluştu'
                        this.snackbar = true

                        this.load1 = true
                        this.progress = false
                    }
                })

            } else if (this.aramayapildi == false && valsec == true) {
                this.secilenkayitlar = this.secilenkayitlaryedek;

            } else if (this.aramayapildi == false && valsec == false && this.nereden == 0) {

                this.secilenkayitlar = [];

            } else if (this.aramayapildi == false && valsec == true && this.nereden == 1) {
                this.nereden = 0;

            }

        },
        searchcari(val) {
            val && this.carigetir(val)
        },
        yenicarisearch(valcari) {
            valcari && this.carigetiryeni(valcari)
        },
        yenicarigecicisearch(valcarigecici) {
            valcarigecici && this.carigetirgecici(valcarigecici)
        },
        'geciciyenicari': function (cari) {
            //  cariservisgetir();
        },

        'GeciciCari.SatisSekli': function (value3) {

            if (value3 == 'K') {
                this.bankaposshow = false;
                this.kredikartshow = false;
                this.servisposshow = false;
                this.GeciciCari.KrediKartNo = null;
                this.GeciciCari.KKCins = null;
                this.GeciciCari.KKAy = null;
                this.GeciciCari.KKYil = null;
                this.GeciciCari.PosKod = null;
                this.GeciciCari.TaksitKod = null;
                this.GeciciCari.ServisPosKod = null;
                this.GeciciCari.ServisTaksitKod = null;
            } else if (value3 == 'P') {
                this.bankaposshow = false;
                this.kredikartshow = false;
                this.servisposshow = false;
                this.GeciciCari.KrediKartNo = null;
                this.GeciciCari.KKCins = null;
                this.GeciciCari.KKAy = null;
                this.GeciciCari.KKYil = null;
                this.GeciciCari.PosKod = null;
                this.GeciciCari.TaksitKod = null;
                this.GeciciCari.ServisPosKod = null;
                this.GeciciCari.ServisTaksitKod = null;
            } else if (value3 == 'R') {
                this.bankaposshow = true;
                this.kredikartshow = true;
                this.servisposshow = true;
            } else if (value3 == 'C') {
                this.bankaposshow = true;
                this.kredikartshow = true;
                this.servisposshow = false;
                this.GeciciCari.ServisPosKod = null;
                this.GeciciCari.ServisTaksitKod = null;
            } else if (value3 == 'F') {
                this.bankaposshow = true;
                this.servisposshow = true;
                this.kredikartshow = true;

            }

        },
        sayfalama(value) {
            this.BiletListele(value, this.siralamatipi, this.kayitadet,
                true)
            // this.secilenkayitlar=this.secilenkayitlaryedek

        },

        'siralamatipi': function (valuetip) {
            this.BiletListele(1, valuetip, this.kayitadet, true)

        },
        'kayitadet': function (valueveriadet) {
            this.BiletListele(1, this.siralamatipi, valueveriadet, true)
        },
        'ListInput.Filtreler.BiletTipi': function (bt) {
            if (bt == 'S') {
                this.bilettipisatisOnay = true
            } else {
                this.bilettipisatisOnay = false

            }

            if (bt == 'I') {
                this.bilettipiiadeOnay = true
            } else {
                this.bilettipiiadeOnay = false
            }

            if (bt == 'I' || bt == 'S') {
                this.bilettipisatisiadeOnay = true
            } else {
                this.bilettipisatisiadeOnay = false
            }

        },
        'ListInput.Filtreler.FaturaStatus': function (fs) {
            if (fs == 1) {
                this.faturatipifaturalanmamislarOnay = true
            } else {
                this.faturatipifaturalanmamislarOnay = false
            }
        },
        'ListInput.Filtreler.CariKod': function (cari) {
            if (cari != null && cari != '') {
                this.cariOnay = true
            } else {
                this.cariOnay = false
            }
        },
        'ListInput.Filtreler.HatTipi': function (yon) {

            if (yon != null && yon != '') {
                this.tekhattpiiOnay = true
            } else {
                this.tekhattpiiOnay = false
            }

        },
        'ListInput.Filtreler.GeciciCari': function (val) {
            if (val == 2) {
                this.gecicarilerOnay = true
            } else {
                this.gecicarilerOnay = false

            }
        },
        'ListInput.Filtreler.DekontBas': function (val) {
            if (val == true) {
                this.dekontbasilanOnay = true
            } else {
                this.dekontbasilanOnay = false
            }
        },

        'ListInput.Filtreler.IadeFatura': function (val) {
            if (val == true) {
                this.iadefaturasigelmeyenOnay = true
            } else {
                this.iadefaturasigelmeyenOnay = false
            }
        },
        'ListInput.Filtreler.GiderPusulasi': function (val) {
            if (val == 2) {
                this.iadebelgedekontOnay = true
            } else {
                this.iadebelgedekontOnay = false
            }
        },
        'ListInput.Filtreler.AcentaFatNo': function (val) {
            if (val == 2) {
                this.acentefatnoOnay = true
            } else {
                this.acentefatnoOnay = false
            }
        },
        gorunumtipi(value2) {
            if (value2 == 'table') {
                
                this.tablegorunum = true
                this.listegorunum = false
                this.vmodelpagination = false
                this.listegorunum = false

                this.yedekListInput.Paging.SayfaNo = 0
                this.yedekListInput.Paging.VeriAdet = null
                this.yedekListInput.Paging.SiralamaTip = null

                var Params = this.yedekListInput;
                this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.itemsticket = response.body

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Hata Oluştu'
                        this.snackbar = true
                        this.load1 = true
                        this.progress = false
                    } else {
                        this.text1 = 'Hata Oluştu'
                        this.snackbar = true

                        this.load1 = true
                        this.progress = false
                    }
                })

            } else {
                this.tablegorunum = false
                this.listegorunum = true
                this.vmodelpagination = true
                this.listegorunum = true
            }
        }
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },

        bakiyekontrol: function (m) {
            return helpers.bakiyekontrol(m);
        }
    }
}

function filtrekayit() {
    this.filtrevarmi = true;

    if (this.filtrecaridegistirView == true) {
        if (this.cariOnay == true && this.bilettipisatisOnay == true && this.faturatipifaturalanmamislarOnay ==
            true) {
            this.caridegistirBtn = true;
            this.voidyapBtn = false;
            this.gecicicaridegistirBtn = false
            this.iadeekleBtn = false
            this.alisfaturanoBtn = false
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
            this.dialogfiltre = false
        } else {
            this.voidyapBtn = false;
            this.caridegistirBtn = false
            this.gecicicaridegistirBtn = false
            this.iadeekleBtn = false
            this.alisfaturanoBtn = false
            this.text1 = 'Lütfen filtreleri tamamlayınız.'
            this.snackbar = true
        }

    } else if (this.filtregecicicaridegistirView == true) {

        if (this.tekhattpiiOnay == true && this.bilettipisatisOnay == true && this
            .faturatipifaturalanmamislarOnay ==
            true && this.gecicarilerOnay == true) {

            this.gecicicaridegistirBtn = true;
            this.voidyapBtn = false;
            this.caridegistirBtn = false
            this.iadeekleBtn = false
            this.alisfaturanoBtn = false
            this.dialogfiltre = false
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
        } else {
            this.voidyapBtn = false;
            this.caridegistirBtn = false
            this.gecicicaridegistirBtn = false
            this.iadeekleBtn = false
            this.alisfaturanoBtn = false
            this.text1 = 'Lütfen filtreleri tamamlayınız.'
            this.snackbar = true
        }

    } else if (this.filtrevoidyapView == true) {

        if (this.bilettipisatisOnay == true && this.faturatipifaturalanmamislarOnay == true) {

            this.voidyapBtn = true;
            this.caridegistirBtn = false
            this.gecicicaridegistirBtn = false
            this.iadeekleBtn = false
            this.alisfaturanoBtn = false

            this.dialogfiltre = false
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
        } else {
            this.voidyapBtn = false
            this.caridegistirBtn = false
            this.gecicicaridegistirBtn = false
            this.iadeekleBtn = false
            this.alisfaturanoBtn = false

            this.text1 = 'Lütfen filtreleri tamamlayınız.'
            this.snackbar = true
        }

    } else if (this.filtreiadekontrolView == true) {

        if (this.bilettipiiadeOnay == true && this.cariOnay == true && this.dekontbasOnay == true && this
            .giderpusulaOnay == true && this.iadefaturagelmeyenOnay == true) {

            this.iadeekleBtn = true;
            this.caridegistirBtn = false
            this.gecicicaridegistirBtn = false
            this.voidyapBtn = false
            this.alisfaturanoBtn = false

            this.dialogfiltre = false
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
        } else {
            this.iadeekleBtn = false
            this.caridegistirBtn = false
            this.gecicicaridegistirBtn = false
            this.voidyapBtn = false
            this.alisfaturanoBtn = false
            this.text1 = 'Lütfen filtreleri tamamlayınız.'
            this.snackbar = true
        }
    } else if (this.filtrealisfaturaView == true) {

        if (this.bilettipisatisiadeOnay == true && this.acentefatnoOnay == true) {

            this.alisfaturanoBtn = true;
            this.caridegistirBtn = false
            this.gecicicaridegistirBtn = false
            this.voidyapBtn = false
            this.iadeekleBtn = false
            this.dialogfiltre = false
            this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
        } else {
            this.alisfaturanoBtn = false
            this.caridegistirBtn = false
            this.gecicicaridegistirBtn = false
            this.voidyapBtn = false
            this.iadeekleBtn = false
            this.text1 = 'Lütfen filtreleri tamamlayınız.'
            this.snackbar = true
        }

    } else {
        this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
        this.dialogfiltre = false
    }

}

function filtreiptal() {
    this.filtrevarmi = false;
    this.ListInput.BiletNo = null;
    this.ListInput.Filtreler.IadeFatura = false;
    this.ListInput.Filtreler.GiderPusulasi = 0;
    this.ListInput.Filtreler.AcentaFatNo = 0;
    this.ListInput.Filtreler.FaturaStatus = 0;
    this.ListInput.Filtreler.GeciciCari = 0;
    this.ListInput.Filtreler.Havayollari = [];
    this.ListInput.Filtreler.Parkurlar = [];
    this.ListInput.Filtreler.HatTipi = [];
    this.ListInput.Filtreler.BiletTipi = 'S';
    this.ListInput.Filtreler.Ucus1 = null;
    this.ListInput.Filtreler.Ucus2 = null;
    this.ListInput.Filtreler.KesenKisi = null;
    this.ListInput.Filtreler.PosKod = null;
    this.ListInput.Filtreler.KrediKartNo = null;
    this.ListInput.Filtreler.DekontBas = false;
    this.ListInput.Filtreler.BaslangicTutar = 0;
    this.ListInput.Filtreler.BitisTutar = 0;
    this.ListInput.Filtreler.TutarTip = 0;

    this.dialogfiltre = false;
    this.filtrealert = false;

    this.BiletListele(this.sayfalama, this.siralamatipi, this.kayitadet,
        false)
    this.secilenkayitlar = []

    this.filtreUyarimesaj = false

    //carikoddeğiştir için bunlar
    this.filtrecaridegistirView = false
    this.bilettipisatisOnay = false
    this.faturatipifaturalanmamislarOnay = false
    this.gecicicaridegistirBtn = false
    this.filtregecicicaridegistirView = false
    this.tekhattpiiOnay = false
    this.gecicarilerOnay = false
    this.caridegistirBtn = false
    this.voidyapBtn = false
    this.filtrevoidyapView = false
    this.filtreiadekontrolView = false
    this.bilettipiiadeOnay = false
    this.cariOnay = false
    this.dekontbasOnay = false
    this.giderpusulaOnay = false
    this.iadefaturagelmeyenOnay = false
    this.iadeekleBtn = false
    this.filtrealisfaturaView = false
    this.bilettipisatisiadeOnay = false
    this.acentefatnoOnay = false
    this.alisfaturanoBtn = false

}

function carigetir(v) {

    if (v.length >= 0) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.loading = true
        var params = {
            q: v,
            c: credentials.SirketKodu,
        }
        setTimeout(() => {

            this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.statecari = response.body
                this.Error = false
            }, (response) => {
                if (response.status === 0) {
                    this.text = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text = 'Service Unavailable'
                    this.snackbar = true
                }
            })
            this.loading = false
        }, 500)
    }
}

function carigetirgecici(v) {
    if (v.length >= 0) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.loading = true
        var params = {
            q: v,
            c: credentials.SirketKodu,
        }

        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.statecarigecic = response.body
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
            }
        })
        this.loading = false

    }
}

function carigetiryeni(v) {
    if (v.length >= 0) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.loading = true
        var params = {
            q: v,
            c: credentials.SirketKodu,
        }
        setTimeout(() => {
            this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.statecariyeni = response.body
                this.Error = false
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })
            this.loading = false
        }, 500)
    }
}

function git(v) {
    if (v.GenelBilgileri.Status == 'S' || v.GenelBilgileri.Status == 'Ia') {
        var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v
            .GenelBilgileri
            .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
        window.open(url, '_blank')
    } else if (v.GenelBilgileri.Status == 'V') {
        var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v
            .GenelBilgileri
            .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
        window.open(url, '_blank')
    }
}

function gitliste(Status, HavaYoluKodu, BiletNo, UcusTipi) {
    if (Status == 'S' || Status == 'Ia') {
        var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + HavaYoluKodu + '&biletno=' + BiletNo +
            '&ucustipi=' +
            UcusTipi
        window.open(url, '_blank')
    } else if (Status == 'V') {
        var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + HavaYoluKodu + '&biletno=' + BiletNo +
            '&ucustipi=' + UcusTipi
        window.open(url, '_blank')
    }
}

function filtrele() {

    this.dialogfiltre = true;

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsairlinelist = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable'
            this.progress = false

            this.snackbar = true
        }
    })

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsparkur = response.body

        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-parkur'
            this.snackbar = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable-parkur'
            this.snackbar = true
            this.progress = false
        }
    })

    this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.bankapositems = response.body
        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-bankpos'
            this.progress = false
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-bankpos'
            this.snackbar = true
            this.progress = false
        }
    })

}

function beforeMount() {
}

function gecicicarikoddegistir() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var biletlistesi = [];

    if (this.secilenkayitlar.length > 0) {
        var biletlistesi = [];
        this.secilenkayitlar.forEach(element => {
            var yenikayit = {
                SirketKodu: credentials.SirketKodu,
                HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                FormNo: element.GenelBilgileri.Formno,
                BiletNo: element.GenelBilgileri.BiletNo
            }
            biletlistesi.push(yenikayit)

        });

        var params = {
            Inputlar: this.ListInputYedek,
            Biletler: biletlistesi,
            YeniCari: this.geciciyenicari,
            Degisikliker: this.GeciciCari
        }
        this.$http.post(auth.API_URL + 'api/Ticket/TicketTempCurrentChange', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;

            if (response.body.Status == true) {
                this.gecicicaridialogsor = false;
                this.gecicicaridialog = false;
                this.secilenkayitlar = [];
                this.BiletListele(1, this.siralamatipi, this.kayitadet, true)

            }

            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.progress = false

                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable'
                this.progress = false

                this.snackbar = true
            }
        })

    } else {
        this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
        this.snackbar = true;
    }

}

function carikoddegistir() {
    if (this.$refs.formcari.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var biletlistesi = [];

        if (this.secilenkayitlar.length > 0) {
            var biletlistesi = [];

            this.secilenkayitlar.forEach(element => {

                var yenikayit = {
                    SirketKodu: credentials.SirketKodu,
                    HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                    FormNo: element.GenelBilgileri.Formno,
                    BiletNo: element.GenelBilgileri.BiletNo
                }
                biletlistesi.push(yenikayit)

            });
            var params = {
                Inputlar: this.ListInput,
                Biletler: biletlistesi,
                YeniCari: this.yenicari
            }
            this.$http.post(auth.API_URL + 'api/Ticket/TicketCurrentChange', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.text1 = response.body.ResponseMessage;
                this.snackbar = true;
                if (response.body.Status == true) {
                    this.caridialog = false
                    this.secilenkayitlar = [];
                    this.BiletListele(1, this.siralamatipi, this.kayitadet, true)
                }

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.progress = false

                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.progress = false

                    this.snackbar = true
                }
            })

        } else {
            this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
            this.snackbar = true;
        }

    }
}

function topluvoidyap() {

    if (this.$refs.formvoid.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var manage = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
        var biletlistesi = [];

        if (this.secilenkayitlar.length > 0) {

            var params = {
                MusteriID: credentials.MusteriID,
                HareketTip: 'Void',
                HareketSayisi: this.secilenkayitlar.length
            }

            this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                if (response.body.UyelikStatus == true) {

                    if (response.body.KontorStatus == true) {

                        var biletlistesi = [];

                        this.secilenkayitlar.forEach(element => {

                            var yenikayit = {
                                SirketKodu: credentials.SirketKodu,
                                HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                                FormNo: element.GenelBilgileri.Formno,
                                BiletNo: element.GenelBilgileri.BiletNo,
                                UcusTipi: element.GenelBilgileri.UcusTipi,
                                IssueDate: this.voiddate,
                                BiletNoSon: null,
                                Login: {
                                    UserID: manage.UserInfo.UserID,
                                    Email: manage.UserInfo.Email
                                }
                            }
                            biletlistesi.push(yenikayit)

                        });
                        var params = {
                            Inputlar: this.ListInput,
                            Biletler: biletlistesi
                        }
                        this.$http.post(auth.API_URL + 'api/Ticket/VoidMultiAdd', params, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {

                            if (response.body.Status == true) {
                                this.caridialog = false
                                this.secilenkayitlar = [];
                                this.voidyapBtn = false
                                this.BiletListele(1, this.siralamatipi, this.kayitadet, true)

                            }
                            this.text1 = response.body.ResponseMessage;
                            this.snackbar = true;
                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = 'Service Unavailable-VoidMultiAdd'
                                this.progress = false

                                this.snackbar = true
                            } else {
                                this.text1 = 'Service Unavailable-VoidMultiAdd'
                                this.progress = false

                                this.snackbar = true
                            }
                        })

                    } else {
                        this.caridialog = false

                        this.text1 =
                            'İşleminiz için yeterli kontörünüz bulunmamaktadır. İşleminize devam etmek için kontör almanız gerekmektedir.'
                        this.snackbar = true
                    }

                } else {
                    this.caridialog = false

                    this.text1 =
                        'Üyelik süreniz sona ermiştir. İşleminize devam etmek için üyeliğinizi yenilemeniz gerekmektedir.'
                    this.snackbar = true
                }

            }, (response) => {

                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-PackageCustomerInfos'
                    this.snackbar = true
                    islemok = false
                } else {
                    this.text1 = 'Service Unavailable-PackageCustomerInfos'
                    this.snackbar = true
                }
            })

        } else {
            this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
            this.snackbar = true;
        }

    }

}

function geleniadefaturisle() {

    if (this.$refs.formiade.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var manage = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
        var biletlistesi = [];

        if (this.secilenkayitlar.length > 0) {

            var biletlistesi = [];

            this.secilenkayitlar.forEach(element => {

                var yenikayit = {
                    SirketKodu: credentials.SirketKodu,
                    HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                    FormNo: element.GenelBilgileri.Formno,
                    BiletNo: element.GenelBilgileri.BiletNo,
                    IadeTarihi: element.TarihBilgileri.IadeTarihi
                }
                biletlistesi.push(yenikayit)

            });

            var params = {
                Inputlar: this.ListInput,
                Biletler: biletlistesi,
                IadeFaturaTarih: this.iadefattarih,
                IadeFaturaNo: this.faturaBelgeNo,
                IadeBelgeNo: this.faturaIadeBelgeNo,
            }

            this.$http.post(auth.API_URL + 'api/Ticket/RefundInvoiceSave', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                if (response.body.Status == true) {
                    this.caridialog = false
                    this.secilenkayitlar = [];

                    setTimeout(function () {
                        //  this.filtreiptal();
                        this.BiletListele(1, this.siralamatipi, this.kayitadet, true)
                    }.bind(this), 3000)

                }

                this.text1 = response.body.ResponseMessage;
                this.snackbar = true;
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.progress = false

                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.progress = false

                    this.snackbar = true
                }
            })

        } else {
            this.text1 = 'işleminize devam edebilmek için bilet seçmeniz gerekmektedir.'
            this.snackbar = true;
        }
    }

}

function sayfala(dizi, baslangic, aralik, indexsayisi, siralamatipi) {

    var yenidizi = [];
    this.filtreticket = [];
    var sortdizi = [];
    sortdizi = dizi;
    if (siralamatipi == 0) {
        dizi.sort(function (a, b) {
            return a.TarihBilgileri.SatisTarihi > b.TarihBilgileri.SatisTarihi ? 1 : a.TarihBilgileri
                .SatisTarihi <
                b.TarihBilgileri.SatisTarihi ? -1 : 0;
        });
    } else if (siralamatipi == 1) {
        dizi.sort(function (a, b) {
            return b.TarihBilgileri.SatisTarihi > a.TarihBilgileri.SatisTarihi ? 1 : b.TarihBilgileri
                .SatisTarihi <
                a.TarihBilgileri.SatisTarihi ? -1 : 0;
        });

    } else if (siralamatipi == 2) {
        dizi.sort(function (a, b) {
            return a.GenelBilgileri.BiletNo > b.GenelBilgileri.BiletNo ? 1 : a.GenelBilgileri.BiletNo <
                b.GenelBilgileri.BiletNo ? -1 : 0;
        });

    } else if (siralamatipi == 3) {

        dizi.sort(function (a, b) {
            return b.GenelBilgileri.BiletNo > a.GenelBilgileri.BiletNo ? 1 : b.GenelBilgileri.BiletNo <
                a.GenelBilgileri.BiletNo ? -1 : 0;
        });

    } else {

        dizi.sort(function (a, b) {
            return a.TarihBilgileri.SatisTarihi > b.TarihBilgileri.SatisTarihi ? 1 : a.TarihBilgileri
                .SatisTarihi <
                b.TarihBilgileri.SatisTarihi ? -1 : 0;
        });

    }

    if (dizi.length > 0) {

        this.kayitvarmi = true;

        this.pagenumber = Math.ceil(dizi.length / indexsayisi);

        yenidizi = dizi.slice(1 * baslangic, (1) * aralik);

        var editdizi = [];

        yenidizi.forEach(element => {
            var yenikayit = [];
            yenikayit.TutarBilgileri = element.TutarBilgileri;
            yenikayit.FaturaBilgileri = element.FaturaBilgileri;
            yenikayit.GenelBilgileri = element.GenelBilgileri;
            var tarih = {
                SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
                IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi)
            }
            yenikayit.TarihBilgileri = tarih;

            var fatura = {
                FaturaNo: element.FaturaBilgileri.FaturaNo,
                FaturaSeri: element.FaturaBilgileri.FaturaSeri,
                FaturaTarihi: tarihkontrol(element.FaturaBilgileri.FaturaTarihi)
            }
            yenikayit.FaturaBilgileri = fatura;
            editdizi.push(yenikayit)
        });
        this.filtreticket = editdizi;
    } else {
        this.kayitvarmi = false;
        this.vmodelpagination = false;
    }
}

function tarihkontrol(v) {

    if (v != "0001-01-01T00:00:00") {
        var parts = v.split("T");
        var parts1 = parts[0].split("-");
        return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
    } else {
        return null;
    }
}

function odemeseklikontrol(v) {

    if (v == "K") {
        return ("K-Kredili");
    } else if (v == "P") {
        return ("P-Peşin");
    } else if (v == "R") {
        return ("R-Kartlı");
    } else if (v == "C") {
        return ("C-Kartlı");
    } else if (v == "F") {
        return ("F-Kredi Kartlı");
    } else {
        return null;
    }
}

function vergihesapla(tutarlar) {

    var gosterilecektutar = 0;

    gosterilecektutar = tutarlar.AlanVergiTutar.AlanVergiTutar + tutarlar.YFFTutar.YFFTutar + tutarlar.TaxTutar
        .TaxTutar +
        tutarlar.KaTutar.KaTutar;
    gosterilecektutar = Math.round(gosterilecektutar * 100) / 100

    return (gosterilecektutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
}

function servishesapla(tutarlar) {
    var gosterilecektutar = 0;
    // gosterilecektutar = tutarlar.ServisTutar.ServisTutar + tutarlar.ReserveTutar.ReserveTutar + tutarlar
    //     .DigerServisTutar
    //     .DigerServisTutar - tutarlar.IskontoTutar.IskontoTutar;

    gosterilecektutar = tutarlar.ServisTutar.ServisTutar - tutarlar.IskontoTutar.IskontoTutar;

    gosterilecektutar = Math.round(gosterilecektutar * 100) / 100
    return (gosterilecektutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
}

function BiletListele(pagenumber, siralamatipi, veriadet, filtre, aranankelime) {
    //anabiletlistele

    if (this.$refs.formbiletrapor.validate()) {

        var bastarih = new Date(this.date)
        var bittarih = new Date(this.date2)

        if (bastarih <= bittarih) {
            this.paginationDisabled = true;

            this.progress = true
            this.load1 = false
            this.load = true

            if (filtre != true) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                this.ListInput.TextSearch = aranankelime
                this.ListInput.Filtreler.CariKod = credentials.CariBilgi.Kod
                this.tumunuseckaldir = false;
                this.secilenkayitlar = [];
                this.aramayapildi = true;
                this.ListInput.SirketKodu = credentials.CariBilgi.SirketKodu
                this.ListInput.BaslangicTarihi = this.date
                this.ListInput.BitisTarihi = this.date2
                this.ListInput.Paging.SayfaNo = 1
                this.ListInput.Paging.VeriAdet = 50
                this.ListInput.Paging.SiralamaTip = 'SalesDate'
                this.ListInputYedek = this.ListInput;

            } else {
                this.ListInput.TextSearch = null
                this.searchliste = null
                this.ListInput.Filtreler.CariKod = credentials.CariBilgi.Kod
                this.ListInput.SirketKodu = credentials.CariBilgi.SirketKodu
                this.ListInput.Filtreler.FaturaTarihi = null
                this.ListInput.Filtreler.FaturaNo = null
                this.ListInput.Filtreler.FaturaSeri = null
                this.ListInput.Filtreler.HatTipi = null
                this.ListInput = this.ListInputYedek;
                this.ListInput.Paging.SayfaNo = pagenumber;
                this.ListInput.Paging.VeriAdet = veriadet;
                this.ListInput.Paging.SiralamaTip = this.siralamatipi

            }

            this.yedekListInput = this.ListInput;

            var Params = this.ListInput;
           
            this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                //  this.itemsticket = response.body

                if (response.body.length > 0) {
                    this.paginationDisabled = false;

                    this.kayitvarmi = true;
                    this.pagenumber = response.body[0].TotalPage;
                    this.vmodelpagination = true;
                    this.recordcount = 'Toplam ' + response.body[0].TotalCount + ' kayıt listelendi';
                    var editdizi = [];

                    response.body.forEach(element => {

                        var yenikayit = [];

                        yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                        yenikayit.GenelBilgileri = element.GenelBilgileri;

                        var tarih = {
                            SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
                            IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
                            IptalTarihi: tarihkontrol(element.TarihBilgileri.IptalTarihi)
                        }

                        yenikayit.TarihBilgileri = tarih;

                        var fatura = {
                            FaturaNo: element.FaturaBilgileri.EfaturaBilgileri.FaturaNo,
                            FaturaTarihi: tarihkontrol(element.FaturaBilgileri
                                .EfaturaBilgileri
                                .GercekFaturaTarihi),
                            FaturaDurumu: element.FaturaBilgileri.EfaturaBilgileri
                                .FaturaDurumu
                        }

                        yenikayit.FaturaBilgileri = fatura;

                        var TutarBilgileri = {
                            AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
                            CezaTutar: {
                                CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
                            },
                            CharterTutar: element.TutarBilgileri.CharterTutar,
                            DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
                            IskontoTutar: element.TutarBilgileri.IskontoTutar,
                            KaTutar: element.TutarBilgileri.KaTutar,
                            NetTutar: {
                                NetTutar: element.TutarBilgileri.NetTutar.NetTutar.toFixed(
                                        2)
                                    .replace(
                                        /(\d)(?=(\d{3})+\.)/g, '$1,')
                            },
                            PtaTutar: element.TutarBilgileri.PtaTutar,
                            ReserveTutar: element.TutarBilgileri.ReserveTutar,
                            ServisTutar: {
                                ServisTutar: element.TutarBilgileri.ServisTutar.ServisTutar
                            },
                            TaxTutar: element.TutarBilgileri.TaxTutar,
                            Tutar: {
                                Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2)
                                    .replace(
                                        /(\d)(?=(\d{3})+\.)/g, '$1,')
                            },
                            YFFTutar: element.TutarBilgileri.YFFTutar,
                            Vergiler: vergihesapla(element.TutarBilgileri),
                            ServisBedeli: servishesapla(element.TutarBilgileri),
                            GosterilecekTutar: this.getTutarBilgileri(element.TutarBilgileri)
                        }

                        yenikayit.TutarBilgileri = TutarBilgileri;
                        var OdemeBilgileri = {
                            SatisSekli: odemeseklikontrol(element.OdemeBilgileri.SatisSekli)
                        }
                        yenikayit.OdemeBilgileri = OdemeBilgileri;
                        editdizi.push(yenikayit)
                    });

                    this.filtreticket = editdizi;
                    //   this.secilenkayitlar = this.secilenkayitlaryedek

                } else {
                    this.filtreticket = [];
                    this.kayitvarmi = false;
                    this.vmodelpagination = false;
                    this.recordcount = ""
                    this.text1 = 'Kayıt Bulunamadı....'
                    this.snackbar = true
                }

                this.progress = false
                this.load1 = true
                this.load = false

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                    this.load1 = true
                    this.progress = false
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true

                    this.load1 = true
                    this.progress = false

                }
            })
        } else {
            this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
            this.snackbar = true
        }
    }
}
</script>

<style>
.v-list__tile__content {
    overflow: inherit;
}
</style>
